import create from 'zustand';

import { BondInfoType } from '../constants';

interface State {
  modalInfoType: BondInfoType;
}

interface Action {
  openInfoModal(infoType: BondInfoType): void;
  closeInfoModal(): void;
}

type Store = State & Action;

const initialState: State = {
  modalInfoType: BondInfoType.UNSPECIFIED,
};

export const useBondInfoModal = create<Store>((set) => ({
  ...initialState,

  openInfoModal(infoType) {
    set({ modalInfoType: infoType });
  },

  closeInfoModal() {
    set({ modalInfoType: BondInfoType.UNSPECIFIED });
  },
}));
